(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/login/login.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/login/login.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _svs$ticket_partner$c = svs.ticket_partner.constants.routes,
  START = _svs$ticket_partner$c.START,
  PASSWORD_RECOVERY = _svs$ticket_partner$c.PASSWORD_RECOVERY;
const Email = svs.ui.reactFormInputs.EmailInput;
const TextInput = svs.ui.reactFormInputs.TextInput;
const Form = svs.ui.reactForm.Form;
const Button = svs.ui.ReactButton;
const Link = svs.app.ReactRouter.Link;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const _svs$ticket_partner$l = svs.ticket_partner.login.constants.FORMS.EMAIL,
  EMAIL_LABEL = _svs$ticket_partner$l.EMAIL_LABEL,
  EMAIL_MAX = _svs$ticket_partner$l.EMAIL_MAX,
  EMAIL_REQUIRED_ERROR = _svs$ticket_partner$l.EMAIL_REQUIRED_ERROR,
  EMAIL_NAME = _svs$ticket_partner$l.EMAIL_NAME;
const _svs$ticket_partner$l2 = svs.ticket_partner.login.constants.FORMS.PASSWORD,
  PASSWORD_LABEL = _svs$ticket_partner$l2.PASSWORD_LABEL,
  PASSWORD_NAME = _svs$ticket_partner$l2.PASSWORD_NAME,
  PASSWORD_REQUIRED_ERROR = _svs$ticket_partner$l2.PASSWORD_REQUIRED_ERROR;
const _svs$ticket_partner$l3 = svs.ticket_partner.login.constants.FORMS,
  HEADER = _svs$ticket_partner$l3.HEADER,
  PASSWORD_LINK = _svs$ticket_partner$l3.PASSWORD_LINK,
  LOGIN_BUTTON_LABEL = _svs$ticket_partner$l3.LOGIN_BUTTON_LABEL;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const PageWrapper = svs.ticket_partner.sharedComponents.pageWrapper.PageWrapper;
const Login = _ref => {
  let history = _ref.history;
  const _svs$ticket_partner$u = svs.ticket_partner.useUserContext(),
    isLoggedIn = _svs$ticket_partner$u.isLoggedIn,
    login = _svs$ticket_partner$u.login;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    password = _useState4[0],
    setPassword = _useState4[1];
  const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.hooks.useReturnUrl(START),
    redirectToReturnUrl = _svs$ticket_partner$s.redirectToReturnUrl,
    returnUrl = _svs$ticket_partner$s.returnUrl;
  const PASSWORD_RECOVERY_URL = returnUrl ? "".concat(PASSWORD_RECOVERY, "?returnUrl=").concat(returnUrl) : PASSWORD_RECOVERY;
  useEffect(() => {
    if (isLoggedIn) {
      redirectToReturnUrl();
    }
  }, [isLoggedIn, history, redirectToReturnUrl]);
  const handleSubmit = async (e, formData) => {
    e.preventDefault();
    if (_.values(formData).some(_ref2 => {
      let isValid = _ref2.isValid;
      return !isValid;
    })) {
      return;
    }
    svs.ui.loader.show();
    await login(email, password);
    svs.ui.loader.hide();
  };
  return React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 4
    },
    md: {
      col: 4
    },
    sm: {
      col: 12
    },
    xl: {
      col: 4
    },
    xs: 12
  }, React.createElement(Form, {
    isVertical: true,
    onSubmit: handleSubmit
  }, React.createElement("h1", {
    className: "f-bold"
  }, HEADER), React.createElement(Email, {
    errorMessageRequired: EMAIL_REQUIRED_ERROR,
    id: EMAIL_NAME,
    isRequired: true,
    label: EMAIL_LABEL,
    max: EMAIL_MAX,
    name: EMAIL_NAME,
    onChange: e => setEmail(e.target.value),
    value: email
  }), React.createElement(TextInput, {
    errorMessageRequired: PASSWORD_REQUIRED_ERROR,
    id: PASSWORD_NAME,
    isRequired: true,
    label: PASSWORD_LABEL,
    name: PASSWORD_NAME,
    onChange: e => setPassword(e.target.value),
    type: "password",
    value: password
  }), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-flex-align-items-center margin-3"
  }, React.createElement(Button, {
    inverted: true,
    type: "submit"
  }, LOGIN_BUTTON_LABEL)), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-flex-align-items-center margin-3"
  }, React.createElement(Link, {
    to: PASSWORD_RECOVERY_URL
  }, PASSWORD_LINK))))));
};
svs.ticket_partner.login.Login = Login;

 })(window);